import { CLEAR_SITE_DATA } from '../application/actions';
import {
  RECEIVE_INTEGRATIONS,
  RECEIVE_INTEGRATION_TEMPLATES,
  RECEIVE_INTEGRATION,
  REMOVE_INTEGRATION,
} from './actions';

const initialState = {
  integrationTypes: [],
  integrations: [],
  loadedScope: undefined, // either site id or org
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_INTEGRATIONS: {
      return {
        ...state,
        integrationTypes: action.integrationTypes,
        integrations: action.integrations,
        loadedScope: action.loadedScope,
      };
    }
    case RECEIVE_INTEGRATION_TEMPLATES: {
      return {
        ...state,
        templates: action.templates,
      };
    }
    case RECEIVE_INTEGRATION: {
      const { integration } = action;
      const integrationIndex = state.integrations.findIndex((i) => i.id === integration.id);
      if (integrationIndex < 0) {
        return { ...state, integrations: [...state.integrations, integration] };
      }
      return {
        ...state,
        integrations: [
          ...state.integrations.slice(0, integrationIndex),
          integration,
          ...state.integrations.slice(integrationIndex + 1),
        ],
      };
    }
    case REMOVE_INTEGRATION: {
      const { id } = action;
      const integrationIndex = state.integrations.findIndex((i) => i.id === id);
      if (integrationIndex >= 0) {
        return {
          ...state,
          integrations: [
            ...state.integrations.slice(0, integrationIndex),
            ...state.integrations.slice(integrationIndex + 1),
          ],
        };
      }
      return state;
    }
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return {
        ...state,
        integrationTypes: [],
        integrations: [],
        templates: [],
        loadedScope: undefined, // either site id or org
      };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
